import { render, staticRenderFns } from "./task-popup.vue?vue&type=template&id=84944f40&"
import script from "./task-popup.vue?vue&type=script&lang=js&"
export * from "./task-popup.vue?vue&type=script&lang=js&"
import style0 from "./task-popup.vue?vue&type=style&index=0&id=84944f40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports